export const constant = {
  paginationCount:"10",
  defaultPage:1,
  defaultPageZero:0
}
export const ITEMS_PER_PAGE = 15;
 
export const calculatePageCount = (count, paginationCount) => {
  return Math.ceil(count / paginationCount);
};

export const pgmThreeWheelerConstant = {
  pgmThreeWheeler:"pgm_3w",
}


export const MOBILE_BREAKPOINT = 768;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
};

export const role = {
  superAdmin: 'super_admin',
  superAdmin3w: '3w_super_admin',
  areaHead: 'area_head'
};

export const vehicleType = {
  threeWheeler: "3 Wheeler",
  twoWheeler: "2W",
}

export const pageValue = {
  pageSize: 10,
  statePageSize: 40,
}

export const ALLOWED_2W_CONTENT_TYPES = ['manual', 'training', 'trouble_shooting', 'info_bulletin'];

export const MODULE_VEHICLETYPE = {
  threeWheeler: "3 WHEELER",
  twoWheeler: "2 WHEELER",
}